import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { BrandStatement } from '../components/BrandStatement';
import { About } from '../components/About';
import { Menu } from '../components/Menu';
import { Gallery } from '../components/Gallery';
import { Locations } from '../components/Locations';
import { ReservationForm } from '../components/ReservationForm';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
export function Home() {
  return <div className="min-h-screen bg-brand-primary text-brand-cream font-sans selection:bg-brand-gold selection:text-brand-primary" data-id="element-321">
      <Navbar data-id="element-322" />
      <main data-id="element-323">
        <Hero data-id="element-324" />
        <BrandStatement data-id="element-325" />
        <About data-id="element-326" />
        <Menu data-id="element-327" />
        <Gallery data-id="element-328" />
        <Locations data-id="element-329" />
        <ReservationForm data-id="element-330" />
        <Testimonials data-id="element-331" />
        <FinalCTA data-id="element-332" />
        <Contact data-id="element-333" />
      </main>
      <Footer data-id="element-334" />
      <FloatingWhatsApp data-id="element-335" />
    </div>;
}